export default function authHeader() {
  const accessToken = localStorage.getItem("accessToken");
  const tokenType = localStorage.getItem("tokenType") || "Bearer";

  if (accessToken) {
    return { Authorization: `${tokenType} ${accessToken}` };
  }

  const raw = localStorage.getItem("user");
  if (!raw) return {};

  try {
    const u = JSON.parse(raw);
    if (u?.tokenType && u?.accessToken) {
      return { Authorization: `${u.tokenType} ${u.accessToken}` };
    }
  } catch {}
  return {};
}
